import {
  footballOutline,
  basketballOutline,
  tennisballOutline,
} from 'ionicons/icons';

/**
 * Sport ID constants
 * IDs must match backend API values
 */
export const FOOTBALL = 1;
export const BASKETBALL = 2;
export const ICE_HOCKEY = 4;
export const TENNIS = 5;
export const CRICKET = 6;
export const RUGBY = 7;
export const BASEBALL = 8;
export const AMERICAN_FOOTBALL = 9;
export const VOLLEYBALL = 10;
export const HANDBALL = 11;

/**
 * All sports configuration - single source of truth
 */
export const SPORTS = [
  { id: FOOTBALL, name: 'football', labelKey: 'sports.football' },
  { id: BASKETBALL, name: 'basketball', labelKey: 'sports.basketball' },
  { id: TENNIS, name: 'tennis', labelKey: 'sports.tennis' },
  { id: ICE_HOCKEY, name: 'ice_hockey', labelKey: 'sports.iceHockey' },
  { id: CRICKET, name: 'cricket', labelKey: 'sports.cricket' },
  { id: RUGBY, name: 'rugby', labelKey: 'sports.rugby' },
  { id: BASEBALL, name: 'baseball', labelKey: 'sports.baseball' },
  { id: AMERICAN_FOOTBALL, name: 'american_football', labelKey: 'sports.americanFootball' },
  { id: VOLLEYBALL, name: 'volleyball', labelKey: 'sports.volleyball' },
  { id: HANDBALL, name: 'handball', labelKey: 'sports.handball' },
];

/**
 * Sport icons mapping by ID
 */
const SPORT_ICONS = {
  [FOOTBALL]: footballOutline,
  [BASKETBALL]: basketballOutline,
  [TENNIS]: tennisballOutline,
};

/**
 * Default sport ID (Football)
 */
export const DEFAULT_SPORT_ID = FOOTBALL;

/**
 * Sports available for fixtures/feed filtering
 */
const FILTER_SPORT_IDS = [FOOTBALL, BASKETBALL, TENNIS];

/**
 * Icon name strings (for components using ICON_MAP)
 */
const SPORT_ICON_NAMES = {
  [FOOTBALL]: 'footballOutline',
  [BASKETBALL]: 'basketballOutline',
  [TENNIS]: 'tennisballOutline',
};

/**
 * Feed/filter sports with string icon names and label property
 * For backward compatibility with FeedFiltersModal and feed store
 */
export const FEED_SPORTS = FILTER_SPORT_IDS.map((id) => {
  const sport = SPORTS.find((s) => s.id === id);
  return {
    id: sport.id,
    name: sport.name,
    label: sport.labelKey,
    icon: SPORT_ICON_NAMES[id],
  };
});

/**
 * Get sport icon by ID
 * @param {number} sportId
 * @returns {string} Icon component
 */
export const getSportIcon = (sportId) => {
  return SPORT_ICONS[sportId] || footballOutline;
};

/**
 * Get sport by ID
 * @param {number} sportId
 * @returns {Object|undefined}
 */
export const getSportById = (sportId) => {
  return SPORTS.find((s) => s.id === sportId);
};

/**
 * Get sport with icon attached
 * @param {number} sportId
 * @returns {Object|undefined}
 */
export const getSportWithIcon = (sportId) => {
  const sport = getSportById(sportId);
  if (!sport) {
    return undefined;
  }
  return {
    ...sport,
    icon: getSportIcon(sportId),
  };
};

/**
 * Get sports for fixtures/feed filters (with icons)
 * @returns {Array}
 */
export const getFilterSports = () => {
  return FILTER_SPORT_IDS.map((id) => getSportWithIcon(id));
};

/**
 * Get all sports for onboarding selection
 * Returns with `label` property for backward compatibility
 * @returns {Array}
 */
export const getOnboardingSports = () => {
  return SPORTS.map((sport) => ({
    id: sport.id,
    name: sport.name,
    label: sport.labelKey,
    enabled: false,
  }));
};
